import gwt from '../../api/gwt';
import { mask } from 'vue-the-mask';
import moment from 'moment';
import { Constants } from './Constants';
import api from '../../api/worktime'
import convert from "heic-convert";

// eslint-disable-next-line no-unused-vars
export default {
      directives: {
        mask
      },
    data () {
      return {
        locale: window.navigator.userLanguage || window.navigator.language,
        rawInput: '',
        constants: Constants,
        lastAdminCompany: -1,
        validationRules: {
          required: v => !!v || window.$vue.$t('wkt.client.common.validation-utils.required_field'), //'Es necesario completar este campo',
          requiredBoolean: v => !(!v && v!==false) || 'Es necesario completar este campo',
          emailRequired(v, email) { return (v===false || (v!==false && email && email.trim().length>0)) || window.$vue.$t('wkt.admin.common.validation-utils.email_required'); }, //'Es necesario completar el email',
          maxLength(v, maximum) { return (v || '').length <= maximum || 'El campo excede la longitud máxima permitida (' + maximum + ' caracteres)'; },
          rangeInt(v, minimum, maximum) { return ((v || '') >= minimum && (v || '') <= maximum) || window.$vue.$t('wkt.client.common.validation-utils.required_field') + ' [ ' + minimum + ' - ' + maximum + ' ]'; },
          email: v => !v || /.+@.+\..+/.test(v) || window.$vue.$t('wkt.client.common.validation-utils.invalid_field'),
          cifnif(v, country) { return (country ? gwt.validateCIF(country.id, v) : false) || window.$vue.$t('wkt.client.common.validation-utils.invalid_field'); },
					phone(v, country) { return (country ? gwt.validatePhone(country.id, v) : false) || window.$vue.$t('wkt.client.common.validation-utils.invalid_field'); },
					cp(v, country) { return (country ? gwt.validatePostalCode(country.id, v) : false) || window.$vue.$t('wkt.client.common.validation-utils.invalid_field'); },
					date: v => !v || this.validateDate(v) || 'No es una fecha válida dd/mm/aaaa',
          time: v => !v || this.validateTime(v) || 'No es una hora válida hh::mm:ss',
          decimalSeparator: (v) => {
            return !v || gwt.validateDecimalSeparator(v, window.navigator.userLanguage || window.navigator.language) || window.$vue.$t('wkt.client.common.validation-utils.invalid_field'); },
         isValidRange: v => {
           const num = parseInt(v.replace(',', '.').replace(/[^0-9.]/g, ''));
           return !isNaN(num) && num >= 0 && num <= 100 ? num : window.$vue.$t('wkt.client.common.validation-utils.invalid_field')
         }
          }
      }
    },
    computed: {
      uuid() {
        return this.$store.state.worktime.uuid;
      },
      deviceInfo() {
        return this.$store.state.worktime.deviceInfo;
      },
      turns() {
        return this.$store.state.worktime.turns;
      },
    },
    mounted: function() {
      var self = this;
      this.timeInterval = setInterval(self.updateTimeInterval, 1000);

      var locale = window.navigator.userLanguage || window.navigator.language;
      moment.locale(locale);
    },
    destroy: function() {
      clearInterval(this.timeInterval);
      this.timeInterval=null;
    },
    methods: {

      matchRole(profile,roles) {
        
        for (let role of roles) {
            let permissionName = 'module'+role;
            let permissionValue = -1;
            for (const [key] of Object.entries(profile)) {
                if (key.toLowerCase()===permissionName.toLocaleLowerCase()) {
                    permissionValue = profile[key];
                    break;
                }
            }

            if (permissionValue===1 || permissionValue===2) {
                return true;
            }
        }

        return false;
    },
    matchRoleModify(profile,roles) {
      
      for (let role of roles) {
          let permissionName = 'module'+role;
          let permissionValue = -1;
          for (const [key] of Object.entries(profile)) {
              if (key.toLowerCase()===permissionName.toLocaleLowerCase()) {
                  permissionValue = profile[key];
                  break;
              }
          }

          if (permissionValue===2) {
              return true;
          }
      }

      return false;
  },
      ensureInitCompleted: function() { 
          if (!this.deviceInfo || !this.deviceInfo.enabled || !this.deviceInfo.registered)
          {
             this.$router.push({ name: 'init' });
             return false;
          }

          return true;
      },
      st: function(key) {
       if (key && key.indexOf && key.indexOf('wkt.')==0) {
        return this.$t(key);
       }
       return key;
      },
      updateTimeInterval: function() {
        this.currentTime = moment().format('LLLL');
     },
     formatDate (value) {
        return !value ? '' : new Date(value).toLocaleDateString();
    },
		formatOnlyDate(value) {
      if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit' });
		},
		formatFullDate(value) {
      if (!value) return "";
			var result = new Date(value).toLocaleString([this.$i18n.locale, 'en'], { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
			return result.charAt(0).toUpperCase() + result.slice(1);
		},
		formatLongDate(value) {
      if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit' });
		},
		formatShortDate(value) {
      if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: '2-digit', month: '2-digit', day: '2-digit' });
		},
		formatLongDateTime(value, is24hours) {
      if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: is24hours ? false: undefined });
		},
		formatShortDateTime(value, is24hours) {
      if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: '2-digit', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: is24hours ? false: undefined });
		},
		formatTime(value, is24hours) {
      if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { hour: '2-digit', minute: '2-digit', hour12: is24hours ? false: undefined });
		},
     formatCurrency(value) {
            // Verificar si value es nulo o indefinido
            if (value === null || value === undefined) {
              return '';
            }
            // Convertir el valor a una cadena si no es una cadena
            const stringValue = String(value);
          
            // Obtener el locale del empleado
            
            const locale = gwt.getSessionInformation().employee.locale;
          
            // Crear un objeto Intl.NumberFormat para el locale
            const numFormat = new Intl.NumberFormat(locale, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            // Obtener el decimal correcto según el locale
            const decimalSeparator = numFormat.formatToParts(1.1)[1].value;
            // Reemplazar el decimal incorrecto con el correcto
            if (decimalSeparator === '.' && stringValue.indexOf(',') !== -1) {
              return stringValue.replace(/,/g, '.');
            } else if (decimalSeparator === ',' && stringValue.indexOf('.') !== -1) {
              return stringValue.replace(/\./g, ',');
            } else {
              return stringValue;
            }
          },

		validateJson(json) {
			try {
				JSON.parse(json);
				return true;
			} catch (e) {
				e;
			}
			return false;
		},
    mustRefresh() {
      let currentAdminCompany = gwt.getSessionProfile().companyId;
      let mustRefresh = this.lastAdminCompany>0 && this.lastAdminCompany !== currentAdminCompany;
      this.lastAdminCompany = currentAdminCompany;
      return mustRefresh;
    },
    getEmployeeFullname(employee) {
      if (!employee) {
        return '---';
      }
      return `${employee.lastname}, ${employee.firstname}`;
    },
    getProfileAssetUrl(fileName) {
      if (!fileName) {
        return "img/default-avatar.jpeg";
      }

      const bucketName = "worktime-dev"; // TODO: obtener de configuración
      return "https://storage.googleapis.com/" + bucketName + "/" + fileName;
    },
    getPubilcAssetUrl(fileName) {
      const bucketName = "worktime-dev"; // TODO: obtener de configuración
      return "https://storage.googleapis.com/" + bucketName + "/" + fileName;
    },
    getLongMonthName(month) {
      let m = moment({ year: moment().year(), month: month - 1, date: 1 });
      return m.toDate().toLocaleString([this.$i18n.locale, 'en'], { month: 'long' });
    },
    getLongMonthNameWithYear(month, year) {
      return `${this.getLongMonthName(month)} ${year}`;
    },
    getCurrentYear() {
      return parseInt(moment().format('YYYY'));
    },
    getCurrentMonth() {
      return parseInt(moment().format('M'));
    },
    getCurrentWeek() {
      const numWeek = moment().endOf('week').isoWeek();
      return numWeek;
    },
    getNumOfWeeks(year) {
      const numWeeks = moment({ year: year }).isoWeeksInYear();
      return numWeeks;
    },
    getNumOfWeek(date, month, year) {
      let m = moment({ year: year, month: month - 1, date: date });
      const numWeek = m.isoWeek();
      return numWeek;
    },
    getFirstDayOfWeekIndex() {
      const date = moment().startOf('week').toDate();
      const index = date.getDay();
      return index;
    },
    getNumOfDaysInMonth(month, year) {
      return moment({ year: year, month: month - 1, date: 1 }).daysInMonth();
    },
    getFirstDayOfMonth(month, year) {
      let date = new Date(year, month - 1, 1);

      date.setHours(12);
      date.setMinutes(0);
      date.setSeconds(0);

      return date;
    },
    getLastDayOfMonth(month, year) {
      let m = moment({ year: year, month: month - 1, date: 1 }).endOf('month');

      let date = m.toDate();
      date.setHours(12);
      date.setMinutes(0);
      date.setSeconds(0);

      return date;
    },
    getFirstDayOfFirstWeekInYear(year) {
      let m = moment({ year: year });
      // Check if 1st of January is in the first week of the year
      if (m.week() !== 1) {
        // If not, add a week to the first day of the current week
        m.startOf('week').add(1, 'week');
      }

      let date = m.toDate();
      date.setHours(12);
      date.setMinutes(0);
      date.setSeconds(0);

      return date;
    },
    getLastDayOfLastWeekInYear(year) {
      let m = moment({ year: year }).endOf('week').add(this.getNumOfWeeks(year) - 1, 'week');

      let date = m.toDate();
      date.setHours(12);
      date.setMinutes(0);
      date.setSeconds(0);

      return date;
    },
    getFirstDayOfWeek(week, year) {
      const date = this.getFirstDayOfFirstWeekInYear(year);
      const m = moment(date);
      m.add(week - 1, 'weeks').startOf('week');
      return m.toDate();
    },
    getLastDayOfWeek(week, year) {
      const date = this.getFirstDayOfFirstWeekInYear(year);
      const m = moment(date);
      m.add(week - 1, 'weeks').endOf('week');
      return m.toDate();
    },
    getWeekPeriod(week, year) {
      const firstDay = this.getFirstDayOfWeek(week, year);
      const lastDay = this.getLastDayOfWeek(week, year);

      const startPeriod = firstDay.getDate() + " " + this.getLongMonthName(parseInt(moment(firstDay).format('M')));
      const lastPeriod = lastDay.getDate() + " " + this.getLongMonthName(parseInt(moment(lastDay).format('M')));

      if (firstDay.getFullYear() != lastDay.getFullYear()) {
				return `${startPeriod} ${firstDay.getFullYear()} - ${lastPeriod} ${lastDay.getFullYear()}`;
			} else {
				return `${startPeriod} - ${lastPeriod} ${year}`;
			}
    },
    addDaysToDate(date, numDays) {
      return moment(date).add(numDays, 'days').toDate();
    },
    addMonthsToDate(date, numMonths) {
      return moment(date).add(numMonths, 'months').toDate();
    },
    convertSimpleDateToDate(date) {
      if (!date || !date.year || !date.month || !date.day) {
        return null;
      }
      return new Date(date.year, date.month - 1, date.day, 12, 0, 0);
    },
    convertDateToSimpleDate(date) {
      if (!date) {
        return null;
      }
      return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    },
    convertSimpleTimeToHHMM(time) {
      if (!time || !time.hours || !time.minutes) {
        return null;
      }

      let date = new Date();
      date.setHours(time.hours);
      date.setMinutes(time.minutes);

      return moment(date).format('HH:mm');
    },
    convertDoubleToHHMM(value) {
      if (value === null) {
        return "0:00";
      }

      const sign = value < 0 ? '-' : '';

      // pasamos horas a minutos y redondeamos (evita fallos de redondeo)
      let minutes = Math.round(Math.abs(value) * 60);
      const hours = Math.floor(minutes / 60);
      minutes -= hours * 60;

      return `${sign}${hours}:${minutes.toString().padStart(2, '0')}`;
    },
    isToday(date) {
      if (date === null) {
        return false;
      }
      
      const today = new Date();
      
      if (date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear()) {
        return true;
      }
  
      return false;
    },
    compareSimpleDates(date1, date2) {
      if (date1 === null && date2 === null) {
        return 0;
      }
      if (date1 !== null && date2 === null) {
        return -1;
      }
      if (date1 === null && date2 !== null) {
        return 1;
      }
      
      const dt1 = this.convertSimpleDateToDate(date1);
      const dt2 = this.convertSimpleDateToDate(date2);

      const diff = dt1 - dt2;
  
      return diff;
    },
		convertColorToHex(color) {
			if (!color) {
				return null;
			}

      const colorParts = color.split(' ');

      let colorId = colorParts[0].replace('-', '').toUpperCase();

			if (colorParts.length == 2) {
				colorId += `-${colorParts[1].toUpperCase()}`;
			}

			const index = Constants.COLORS.findIndex(c => c.id === colorId);

			if (index === -1) {
				return color;
			}

      return Constants.COLORS[index].hex;
    },
    getStatusColor(status) {
			let color = "green";

			switch (status) {
				case -1: // PREPARING
				case 0: // PENDING
					color = "orange";
					break; 
				case 2: // DECLINED
				case 3: // CANCELED
					color = "red";
					break;
				case 4: // PROCESSED
					color = "#2196F3";
					break;
			}

			return color;
		},
		getStatusText(status) {
			let text = "???";

			switch (status) {
				case -1: // PREPARING
					text = this.$t('wkt.client.expensesheets.status-type.preparing');
					break;
				case 0: // PENDING
					text = this.$t('wkt.client.expensesheets.status-type.pending');
					break;
				case 1: // APPROVED
					text = this.$t('wkt.client.expensesheets.status-type.approved');
					break;
				case 2: // DECLINED
					text = this.$t('wkt.client.expensesheets.status-type.denied');
					break;
				case 3: // CANCELED
					text = this.$t('wkt.client.expensesheets.status-type.canceled');
					break;
				case 4: // PROCESSED
					text = this.$t('wkt.client.expensesheets.status-type.processed');
					break;
			}

			return text.toUpperCase();
		},		
		getFormatTypeText(formatType) {
			let text = '???';
      
			switch (formatType) {
				case 0:
					text = this.$t('wkt.client.expensesheets.detail-window.items.format-type.ticket');
					break;
				case 1:
					text = this.$t('wkt.client.expensesheets.detail-window.items.format-type.invoice');
					break;
			}

			return text;
		},		
		getPaymentMethodText(paymentMethod) {
			let text = '???';

			switch (paymentMethod) {
				case 0:
					text = this.$t('wkt.client.expensesheets.detail-window.items.payment-method-type.cash');
					break;
				case 1:
					text = this.$t('wkt.client.expensesheets.detail-window.items.payment-method-type.company_card');
					break;
        case 2:
          text = this.$t('wkt.client.expensesheets.detail-window.items.payment-method-type.other');
          break;
			}

			return text;
		},    
		downloadExpenseSheetItemDocumentContentAsBase64(sheetId, sheetItemId, cbok, cberr) {
			api.downloadExpenseSheetItemDocumentContent(sheetId, sheetItemId,
        data => {
          if (cbok) {
            cbok(data);
          }
        }, 
        err => {
          if (cberr) {
            cberr(err);
          }
        }
      );
		},
		async heicToJpg(file, fileName, callback) {
      const inputBuffer = Buffer.from(await file.arrayBuffer());
			const outputBuffer = await convert({
				buffer: inputBuffer, // the HEIC file buffer
        format: 'JPEG', // output format
        quality: 0.5 // the jpeg compression quality, between 0 and 1
			});
      const base64Image = `data:image/jpeg;base64,${outputBuffer.toString('base64')}`;
      const newFile = this.dataURLtoFile(base64Image, `${fileName}.jpg`);
			if (callback) {
        callback(newFile);
      }
		},
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[arr.length - 1]), 
          n = bstr.length, 
          u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
  }
  },
}